var map = {
  "./en/common.json": [
    "Fv",
    [
      "3m"
    ]
  ],
  "./es/common.json": [
    "mfr",
    [
      "k"
    ]
  ],
  "./en/deprecatedCommon.json": [
    "gJ",
    []
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "NY";
module.exports = __rspack_async_context;
